import React from "react";
import underconstruction from "../../../assets/images/UnderConstruction.png"
export default function Admin() {
  
  return (
    <div>
         <img alt="logo" width="20%" src={underconstruction} />
    </div>
  );
}
